import { DocumentationBaseIds } from 'shared/types/documentation';
import { useIssuesOnDocumentation } from 'store/issue';
import { getProcessesWithVisiblePositionOnMap } from 'components/dataProviders/withIssuesOnMap/model';
import { useVisibleFieldsByProcess, useVisibleFieldsLoading } from 'store/visibleFields';
import { ReactElement, useMemo } from 'react';
import { IssueAreas } from './IssueAreas';
import { IssuePins } from './IssuePins';

export function DocumentationIssueLocation({
  file,
  visible,
}: {
  file: DocumentationBaseIds;
  visible: boolean;
}): ReactElement | null {
  const { issues, isUsedAsLevel, loadingLevels } = useIssuesOnDocumentation(file);
  const loadingFieldVisibility = useVisibleFieldsLoading();

  const visibleFields = useVisibleFieldsByProcess();
  const processesWithPositionOnMap = useMemo(
    () => getProcessesWithVisiblePositionOnMap(visibleFields),
    [visibleFields]
  );


  if (
    loadingLevels ||
    loadingFieldVisibility ||
    !isUsedAsLevel ||
    !visible
  ) {
    return null;
  }

  return (
    <>
      <IssueAreas
        issues={issues}
        processesWithPositionOnMap={processesWithPositionOnMap}
      />
      <IssuePins
        issues={issues}
        processesWithPositionOnMap={processesWithPositionOnMap}
      />
    </>
  );
}
